import { workspaceRouter } from "@v2/trpc/routes/workspace";

export const useIsWorkspaceOwner = (workspaceId?: string | null) => {
  const { data } = workspaceRouter.getUserWorkspacesList.useQuery();

  if (!workspaceId) {
    return false;
  }

  const userWorkspaceRole = data?.workspaces.find(
    (workspace) => workspace.id === workspaceId,
  )?.workspaceMemberships[0]?.role;

  return userWorkspaceRole === "owner";
};
